import { z } from 'zod'

export const formSchema = z.object({
  email: z
    .string()
    .email({ message: 'Invalid email format.' })
    .min(10, { message: 'Email must be at least 10 characters long.' }),
  password: z
    .string()
    .min(6, { message: 'Password must be at least 6 characters long.' }),
})

export const loginFields: LoginInputType[] = ['email', 'password']

export type LoginInputType = 'email' | 'password'
